import { cn } from "@/lib/utils";

interface UserAvatarProps {
  avatarUrl?: string | null;
  name?: string | null;
  username?: string | null;
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

const SIZE_CLASSES = {
  sm: "h-6 w-6 text-ui-badge",
  md: "h-8 w-8 text-ui-caption",
  lg: "h-10 w-10 text-ui-control",
  xl: "h-20 w-20 text-ui-title",
} as const;

export function UserAvatar({ avatarUrl, name, username, size = "md", className }: UserAvatarProps) {
  const displayName = name || username || "?";
  const initial = displayName.charAt(0).toUpperCase();

  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full bg-foreground text-background overflow-hidden font-semibold",
        SIZE_CLASSES[size],
        className,
      )}
    >
      {avatarUrl ? (
        <img src={avatarUrl} alt={username ?? ""} className="h-full w-full object-cover" />
      ) : (
        <span>{initial}</span>
      )}
    </div>
  );
}
